import { handlePostAction } from "../../../utils/event-api-invoke";
import { getPricingSettingsAPIPostSchema, getPricingSettingsAuditInfoSchema } from "../create/Schema";

let _isError = false;

const getAuditInfo = (data, auditConfig) => {
  try {
    let _auditSchema = getPricingSettingsAuditInfoSchema();
    let _currentState = {};
    let _prevState = {};
    let _isDeleted = data?.Deleted;
    Object.keys(data).forEach((key) => { //If the record is deleted, previousState will be available. The currentState will be available for creation.
      if (_isDeleted) {
        if (key !== "Deleted") { //We do not send deleted key in state
          _prevState[key] = data[key];
        }
      } else {
        _currentState[key] = data[key];
        _prevState[key] = auditConfig.formdata?.[key]; //formdata will only be available in edit scenario
      }
    });

    _auditSchema.auditInfo[0].shortDesc = data?.Description;
    _auditSchema.auditInfo[0].currentState = JSON.stringify(_currentState);
    _auditSchema.auditInfo[0].previousState = JSON.stringify(_prevState);
    if (auditConfig.editPricingSettingsId) {
      _auditSchema.auditInfo[0].LocationKey = auditConfig.editPricingSettingsId;
      _auditSchema.auditInfo[0].Action = _isDeleted ? "DELETE" : "EDIT";
    } else {
      _auditSchema.auditInfo[0].Action = "CREATE";
    }

    return _auditSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const getPostPayload = (data, config) => {
  try {
    let _postSchema = getPricingSettingsAPIPostSchema(config.countryCode, config.businessCode);

    _postSchema.pricingSettings[0].SettingsKey = data?.SettingsKey;
    _postSchema.pricingSettings[0].SettingsValue = data?.SettingsValue;
    _postSchema.pricingSettings[0].Unit = data?.Unit;
    _postSchema.pricingSettings[0].Description = data?.Description;
    if (config.editPricingSettingsId) {
      _postSchema.pricingSettings[0].SettingsId = config.editPricingSettingsId;
      _postSchema.pricingSettings[0].Deleted = data.Deleted ? data.Deleted : false;
    }

    return _postSchema;
  } catch (err) {
    _isError = true;
    alert(err);
  }
};

const savePricingSettings = async (data, uihandler) => {
  let status = {
    responseStatus: null,
    error: null,
  };
  const {
    EditPricingSettingsId: editPricingSettingsId,
    settingsConfig: { businessCode, countryCode },
    formdata,
  } = uihandler;
  try {
    let _auditInfo = getAuditInfo(data, { editPricingSettingsId, formdata });
    let _postPayload = getPostPayload(data, { editPricingSettingsId, businessCode, countryCode });

    let _postRequest = { ..._postPayload, ..._auditInfo };

    let res = await handlePostAction(_postRequest, "pricingsettings");
    if (res && res.status && res.status === 200) {
      if (res.data.errorNumber > 0) {
        _isError = true;
        status.errorMessage = res.data.errorDescription;
      } else {
        status.responseStatus = res.status;
      }
    }

  } catch (err) {
    _isError = true;
    alert(err);
  } finally {
    return { ...status, error: _isError };
  }
};

export { savePricingSettings };
